import generic_backend_request_post from 'functions/server/generic_backend_request_post';

//json file should have locations and costs
async function get_address_from_coords(json) {
    const retJson = await generic_backend_request_post(json, '/address');
    return retJson;
}

export default get_address_from_coords